import BaseImage from "@components/BaseImage";
import { getImgSrcFromStorage } from "@components/StorageImage";
import BadgeTooltip from "@components/Tooltip/BadgeTooltip";
import { Typography } from "@kelp-dao/kernel-design-system";
import { CSSProperties, useMemo } from "react";
import { TagRow } from "./type";

const BADGE_BG_COLOR = "#EBF8FF";
const BADGE_BG_COLOR_FEATURED = "#D8F0F0";
const BADGE_TEXT_COLOR = "#075A5A";
interface Props {
  allTags: TagRow[];
  tags: string;
  tagWithImage?: string;
  tagImagePath?: string;
  featuredDefi?: boolean;
}

const DeFiTag = ({
  tag,
  style,
}: {
  tag: string;
  featuredDefi?: boolean;
  style?: CSSProperties;
}) => {
  return (
    <div className={``} style={style as CSSProperties}>
      <Typography
        as="p"
        type="body"
        variant="xsmall"
        className="text-text-primary"
      >
        {tag}
      </Typography>
    </div>
  );
};

const DefiRowTags = ({
  tags,
  tagWithImage,
  tagImagePath,
  featuredDefi = false,
}: Props) => {
  const tagItems = useMemo(() => {
    return tags
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag !== "");
  }, [tags]);

  const maxTags = featuredDefi ? 2 : 1;

  return (
    <div className="flex">
      <div className="flex gap-0.5 flex-col">
        <div className="flex gap-0.5">
          {tagItems.length > 0 && tagItems[0] != "" && (
            <div
              className={`${
                featuredDefi ? "" : "flex items-center"
              } rounded-4 bg-bg-primary rounded-md  px-2 py-1`}
            >
              <DeFiTag
                key={tagItems[0]}
                tag={tagItems[0]}
                featuredDefi={featuredDefi}
              />
            </div>
          )}
          {featuredDefi && tagItems.length > 1 && (
            <div
              className={`${
                featuredDefi ? "" : "flex items-center"
              } rounded-4 bg-bg-primary rounded-md  px-2 py-1`}
            >
              <DeFiTag key={tagItems[1]} tag={tagItems[1]} featuredDefi />
            </div>
          )}

          {tagItems.length > maxTags && (
            <BadgeTooltip
              label={`+${tagItems.length - maxTags}`}
              bgColor={featuredDefi ? BADGE_BG_COLOR_FEATURED : BADGE_BG_COLOR}
              contentBgColor={"backgroundCard"}
              textColor={BADGE_TEXT_COLOR}
              content={
                <div className="min-w-[200px] max-w-[300px] px-5 py-2">
                  <Typography
                    type="heading"
                    variant="xsmall"
                    className="text-sm font-semibold mb-0.5 font-sans"
                  >
                    Benefits
                  </Typography>
                  <ul className="px-4">
                    {tagItems.map((tag) => {
                      return <li key={tag}>{tag}</li>;
                    })}
                  </ul>
                </div>
              }
            />
          )}
        </div>
        {!featuredDefi && tagWithImage && tagImagePath && (
          <div className="flex items-center rounded-4 bg-bg-primary rounded-md  px-2 py-1 gap-1 w-max">
            <BaseImage
              width={18}
              height={18}
              src={getImgSrcFromStorage(tagImagePath)}
              alt=""
            />
            <DeFiTag key={tagItems[0]} tag={tagWithImage} />
          </div>
        )}
      </div>
    </div>
  );
};

export default DefiRowTags;
